import React, { useState } from 'react';
import { Menu as MenuIcon } from 'lucide-react';
import Menu from './Menu';
import { IconButton } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import AuthObserver from '../../AuthObserver'; // Firebase onIdTokenChanged


function TitlePage(props) {
    const [menuState, setMenuState] = useState(false)

    const classes = useStyles();
    const navigate = useNavigate();

    const openMenu = () => {
        setMenuState(true);
    }
    const closeMenu = () => {
        setMenuState(false);
    }
    const navigateTo = (destination) => {
        navigate(destination);
    }

    return (
        <div className={classes.titleSection}>
            {props.Login !== null && props.Login.loginState &&
                <AuthObserver  {...props} />
            }
            <div className={classes.titleStyle}>
                {/* {props.Login.loginState &&
                    <div className={classes.headerLeft} style={{ cursor: props.backbutton ? 'pointer' : 'default' }} onClick={props.backbutton ? Back : nothing}>
                        {props.backbutton ?
                            <IconButton onClick={Back} className={classes.arrowBack} >
                                <ChevronLeft color='white' style={{ color: "white" }} />
                            </IconButton> : <React.Fragment></React.Fragment>}
                        <h1 className={props.backbutton === false ? classes.hstylewithoutbutton : classes.hstyle} >{props.Text}</h1>
                    </div>
                } */}
                <div className={classes.headerMiddle}>
                    <img onClick={() => navigateTo('/')} className={classes.taplrLogo} src={process.env.PUBLIC_URL + "/images/Taplr.png"} alt="Taplr Logo"></img>
                </div>

                {props.Login.loginState &&
                    <div className={classes.headerRight}>
                        <Menu {...props} open={menuState} close={closeMenu}></Menu>
                        <div className={classes.aubWerk}>
                            {"Hi, " + props.Login.userName}
                        </div>
                        <IconButton onClick={openMenu} size="large" style={{ color: 'white' }} className={classes.toggleButton}>
                            <MenuIcon fontSize="inherit" />
                        </IconButton>
                    </div>
                }
            </div>
        </div>
    )
}

export default TitlePage;
const useStyles = makeStyles((theme) => ({
    titleSection: {
        width: '100%',
        height: '100px',
        background: "#C3996B !important",
        display: 'flex', justifyContent: 'center',
        position: 'fixed', top: '0px', zIndex: '1000'
    },
    titleTextStyle: {
        marginLeft: "20px",
    },

    hstyle: {
        whiteSpace: 'nowrap',
        [theme.breakpoints.up('md')]: {
            fontSize: "2.5rem",
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: "1.2rem",

        },
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "48px",
        color: 'white'
    },

    hstylewithoutbutton: {
        whiteSpace: 'nowrap',
        [theme.breakpoints.up('md')]: {
            fontSize: "2.5rem",
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: "1.2rem",
        },
        marginLeft: '54px',

        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
        },
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "48px",
        color: 'white'
    },

    titleStyle: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: "flex",
        alignContent: "space-around",
        alignItems: "center",
        justifyContent: "space-between",
        position: 'fixed',

        zIndex: '955',
        top: '0',
        width: '90%',
        [theme.breakpoints.down('md')]: {
            height: '100px',
        },
        [theme.breakpoints.down('lg')]: {
            height: '100px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '100px',
            flexDirection: 'column-reverse',
        },


    },
    headerLeft: {
        paddingLeft: "5%",
        // alignItems: 'center',
        // display: 'flex',
        width: '50%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            paddingLeft: "0%",
            position: "absolute",
            top: '55px',
            justifyContent: 'center'
        },
        color: 'white'

    },
    headerMiddle: {
        width: '50%',
        // display: 'flex',
        // justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            justifyContent: 'center',
            position: "absolute",
            top: '5px',
            height: 'auto'
        },

    },
    aubWerk: {
        display: 'flex',
        fontSize: '1.2rem',
        paddingRight: '10px',
        justifyContent: 'center !important',
        [theme.breakpoints.down('sm')]: {
            display: 'none !important',

        },
        alignItems: 'center !important'


    },

    headerRight: {
        width: '50%',
        display: 'flex',
        justifyContent: 'end',
        color: 'white',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            position: 'fixed',
            top: '105px',
            paddingRight: '5px',
            pointerEvents: 'none', // Make the parent div ignore pointer events
        },
        '& > *': {
            pointerEvents: 'auto', // Restore pointer events for child elements
        },
    },

    toggleButton: {
        marginLeft: '5px',
        [theme.breakpoints.down('sm')]: {
            background: "#C3996B !important",
        },
    },

    arrowBack: {
        zIndex: '999',
        color: 'white',
        padding: '15px',
        [theme.breakpoints.down('sm')]: {
            padding: '5px',
            position: 'absolute !important',
            left: '25px',
            fontSize: '50px !important',
            top: '-50%'
        },
        cursor: 'pointer'
    },
    taplrLogo: {
        marginTop: '15px',
        marginBottom: '15px',
        width: '150px',
        [theme.breakpoints.down('sm')]: {
            width: '100px',
            height: 'auto',
            maxHeight: '46px'
        },
        cursor: 'pointer',
    },
}));